<template>
  <section class="config">
    <button
      class="btn btn-secondary btn-sm mr-1"
      @click="showConfigModal">
      설정
    </button>
    <b-modal
      id="configModal"
      ref="configModal"
      title="설정"
      centered>
      <b-input-group class="mb-1" :prepend="`상금 (${room.prize})`" :append="numToKor(localPrize)">
         <b-form-input
           placeholder="💰 상금을 입력하세요"
           v-model.trim.number="localPrize"
           type="number">
         </b-form-input>
       </b-input-group>

       <b-input-group class="mb-1" :prepend="`변환비 (${room.prizeRatio})`" :append="numToKor(localPrizeRatio)">
         <b-form-input
           placeholder="💰 상금 변환비를 입력하세요"
           v-model.trim.number="localPrizeRatio"
           type="number">
         </b-form-input>
       </b-input-group>

       <div slot="modal-footer" class="container px-0">
         <button class="btn btn-secondary mr-2 float-left" @click="hideConfigModal">
           취소
         </button>
         <button class="btn btn-primary" @click="updateRoom">
           변경
         </button>
       </div>
    </b-modal>
  </section>
</template>

<script>
import {
  // mapGetters,
  mapState
} from 'vuex'
import numToKor from '@/mixins/numToKor'

export default {
  name: 'Settings',

  mixins: [ numToKor ],

  data () {
    return {
      localPrize: 0,
      localPrizeRatio: 0
    }
  },

  computed: {
    ...mapState('room', [
      'room'
    ]),
    stopMsg () {
      if (this.isCast) {
        return '!!!방송종료'
      } else {
        return '시청종료'
      }
    }
  },

  methods: {
    showConfigModal () {
      this.localPrize = this.room.prize
      this.localPrizeRatio = this.room.prizeRatio
      this.$refs.configModal.show()
    },

    hideConfigModal () {
      this.$refs.configModal.hide()
    },

    updateRoom () {
      const capitalize = str => `${str[0].toUpperCase()}${str.slice(1)}`
      this.$store.dispatch('room/updateRoom',
        Object.keys(this.room)
          .filter(k => this[`local${capitalize(k)}`] && this[`local${capitalize(k)}`] !== this.room[k])
          .reduce((acc, k) => {
            acc[k] = this[`local${capitalize(k)}`]
            return acc
          }, {})
      )
      this.hideConfigModal()
    }
  }
}
</script>

<style scoped>
</style>
